"use strict";

var _classCallCheck = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleWarp = void 0;

var Rectangle_1 = require("./Rectangle");

var Circle_1 = require("./Circle");

var CircleWarp = /*#__PURE__*/function (_Circle_1$Circle) {
  _inherits(CircleWarp, _Circle_1$Circle);

  function CircleWarp(x, y, radius, canvasSize) {
    var _this;

    _classCallCheck(this, CircleWarp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CircleWarp).call(this, x, y, radius));
    _this.canvasSize = canvasSize;
    _this.canvasSize = {
      height: canvasSize.height,
      width: canvasSize.width
    };
    return _this;
  }

  _createClass(CircleWarp, [{
    key: "contains",
    value: function contains(point) {
      if (_get(_getPrototypeOf(CircleWarp.prototype), "contains", this).call(this, point)) {
        return true;
      }

      var posNE = {
        x: point.x - this.canvasSize.width,
        y: point.y
      };

      if (_get(_getPrototypeOf(CircleWarp.prototype), "contains", this).call(this, posNE)) {
        return true;
      }

      var posSE = {
        x: point.x - this.canvasSize.width,
        y: point.y - this.canvasSize.height
      };

      if (_get(_getPrototypeOf(CircleWarp.prototype), "contains", this).call(this, posSE)) {
        return true;
      }

      var posSW = {
        x: point.x,
        y: point.y - this.canvasSize.height
      };
      return _get(_getPrototypeOf(CircleWarp.prototype), "contains", this).call(this, posSW);
    }
  }, {
    key: "intersects",
    value: function intersects(range) {
      if (_get(_getPrototypeOf(CircleWarp.prototype), "intersects", this).call(this, range)) {
        return true;
      }

      var rect = range;
      var circle = range;
      var newPos = {
        x: range.position.x - this.canvasSize.width,
        y: range.position.y - this.canvasSize.height
      };

      if (circle.radius !== undefined) {
        var biggerCircle = new Circle_1.Circle(newPos.x, newPos.y, circle.radius * 2);
        return _get(_getPrototypeOf(CircleWarp.prototype), "intersects", this).call(this, biggerCircle);
      } else if (rect.size !== undefined) {
        var rectSW = new Rectangle_1.Rectangle(newPos.x, newPos.y, rect.size.width * 2, rect.size.height * 2);
        return _get(_getPrototypeOf(CircleWarp.prototype), "intersects", this).call(this, rectSW);
      }

      return false;
    }
  }]);

  return CircleWarp;
}(Circle_1.Circle);

exports.CircleWarp = CircleWarp;